import { createFileRoute } from "@tanstack/react-router";

import { AccountSettingsPanel } from "../components/settings/AccountSettingsPanel";

function SettingsAccountRouteView() {
  return <AccountSettingsPanel />;
}

export const Route = createFileRoute("/_app/settings/account")({
  component: SettingsAccountRouteView,
});
